import React from "react";

export default function ColorFrame19({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <g clipPath="url(#clip0_2087_157442)">
          <path
            d="M30.8407 51.7098C24.2541 48.0016 17.485 52.9988 15.7739 55.7338C12.0148 54.293 6.25033 52.4991 2.25467 58.0854C-0.884797 62.4747 -0.078165 69.6146 8.20959 75.0927C14.5441 79.2797 22.432 82.6701 22.6289 81.4007C23.4377 76.1851 28.2356 72.0733 32.1162 68.7079C37.5309 64.012 37.4274 55.418 30.8407 51.7098Z"
            fill="#FF5130"
          />
          <path
            d="M5.99709 28.7459C9.63269 18.5835 20.9437 18.5791 25.37 19.8612C28.0808 14.7778 32.3638 8.4885 42.1774 9.21652C50.6648 9.84615 56.1032 19.8742 53.5985 32.2005C50.8924 45.5184 43.0292 56.9408 42.014 54.8978C39.0629 48.959 27.0157 49.2393 19.6505 49.0699C9.81125 48.8435 2.36149 38.9083 5.99709 28.7459Z"
            fill="#E1472A"
          />
          <path
            d="M7.10864 26.7578C10.6791 16.6278 21.9053 16.6655 26.3033 17.9617C28.9748 12.8978 33.2023 6.63611 42.945 7.39932C51.3712 8.05941 56.8062 18.0892 54.3662 30.3833C51.7299 43.6665 43.9682 55.0385 42.953 52.9954C40.0019 47.0566 28.046 47.2916 20.7354 47.095C10.9691 46.8324 3.53814 36.8878 7.10864 26.7578Z"
            fill="#FF5130"
          />
          <path
            d="M43.7161 15.1941C49.4735 8.72699 58.6659 11.6239 61.5369 13.9509C65.0739 10.992 70.6524 6.90467 77.059 11.4714C82.0928 15.0595 83.874 23.0953 76.9316 32.1127C71.6255 39.0048 64.34 45.6114 63.6546 44.3094C60.8387 38.9592 54.1113 36.2884 48.6553 34.0852C41.0424 31.011 37.9586 21.6612 43.7161 15.1941Z"
            fill="#E1472A"
          />
        </g>
        <g clipPath="url(#clip1_2087_157442)">
          <path
            d="M245.159 51.7098C251.746 48.0016 258.515 52.9988 260.226 55.7338C263.985 54.293 269.75 52.4991 273.745 58.0854C276.885 62.4747 276.078 69.6146 267.791 75.0927C261.456 79.2797 253.568 82.6701 253.371 81.4007C252.562 76.1851 247.765 72.0733 243.884 68.7079C238.469 64.012 238.573 55.418 245.159 51.7098Z"
            fill="#FF5130"
          />
          <path
            d="M270.003 28.7459C266.367 18.5835 255.056 18.5791 250.63 19.8612C247.919 14.7778 243.636 8.4885 233.822 9.21652C225.335 9.84615 219.897 19.8742 222.401 32.2005C225.108 45.5184 232.971 56.9408 233.986 54.8978C236.937 48.959 248.984 49.2393 256.349 49.0699C266.189 48.8435 273.638 38.9083 270.003 28.7459Z"
            fill="#E1472A"
          />
          <path
            d="M268.891 26.7578C265.321 16.6278 254.095 16.6655 249.697 17.9617C247.025 12.8978 242.798 6.63611 233.055 7.39932C224.629 8.05941 219.194 18.0892 221.634 30.3833C224.27 43.6665 232.032 55.0385 233.047 52.9954C235.998 47.0566 247.954 47.2916 255.265 47.095C265.031 46.8324 272.462 36.8878 268.891 26.7578Z"
            fill="#FF5130"
          />
          <path
            d="M232.284 15.1941C226.526 8.72699 217.334 11.6239 214.463 13.9509C210.926 10.992 205.348 6.90467 198.941 11.4714C193.907 15.0595 192.126 23.0953 199.068 32.1127C204.374 39.0048 211.66 45.6114 212.345 44.3094C215.161 38.9592 221.889 36.2884 227.345 34.0852C234.958 31.011 238.041 21.6612 232.284 15.1941Z"
            fill="#E1472A"
          />
        </g>
        <g clipPath="url(#clip2_2087_157442)">
          <path
            d="M74.9112 237.586C68.3245 233.877 61.5554 238.874 59.8443 241.61C56.0853 240.169 50.3208 238.375 46.3251 243.961C43.1856 248.35 43.9923 255.49 52.28 260.968C58.6145 265.155 66.5025 268.546 66.6993 267.276C67.5082 262.061 72.306 257.949 76.1866 254.584C81.6013 249.888 81.4978 241.294 74.9112 237.586Z"
            fill="#FF5130"
          />
          <path
            d="M53.3819 231.84C49.7463 221.678 38.4354 221.674 34.009 222.956C31.2982 217.872 27.0152 211.583 17.2016 212.311C8.71421 212.941 3.27583 222.969 5.78049 235.295C8.48667 248.613 16.3498 260.035 17.365 257.992C20.3161 252.053 32.3634 252.334 39.7286 252.164C49.5678 251.938 57.0175 242.003 53.3819 231.84Z"
            fill="#E1472A"
          />
          <path
            d="M52.2703 229.852C48.6998 219.722 37.4736 219.76 33.0756 221.056C30.4041 215.992 26.1766 209.73 16.4339 210.494C8.00772 211.154 2.57275 221.183 5.01273 233.478C7.64902 246.761 15.4107 258.133 16.4259 256.09C19.377 250.151 31.3329 250.386 38.6435 250.189C48.4098 249.927 55.8408 239.982 52.2703 229.852Z"
            fill="#FF5130"
          />
          <path
            d="M2.42227 191.855C7.4503 184.806 16.9011 186.697 20.0058 188.702C23.2038 185.379 28.3101 180.715 35.1709 184.566C40.5616 187.592 43.1973 195.389 37.2657 205.101C32.7321 212.524 26.1998 219.877 25.3784 218.656C22.0031 213.64 15.0273 211.708 9.36588 210.105C1.46631 207.868 -2.60577 198.905 2.42227 191.855Z"
            fill="#E1472A"
          />
        </g>
        <g clipPath="url(#clip3_2087_157442)">
          <path
            d="M201.089 237.586C207.675 233.877 214.444 238.874 216.156 241.61C219.915 240.169 225.679 238.375 229.675 243.961C232.814 248.35 232.008 255.49 223.72 260.968C217.385 265.155 209.497 268.546 209.301 267.276C208.492 262.061 203.694 257.949 199.813 254.584C194.399 249.888 194.502 241.294 201.089 237.586Z"
            fill="#FF5130"
          />
          <path
            d="M222.618 231.84C226.254 221.678 237.565 221.673 241.991 222.956C244.702 217.872 248.985 211.583 258.798 212.311C267.286 212.941 272.724 222.969 270.22 235.295C267.513 248.613 259.65 260.035 258.635 257.992C255.684 252.053 243.637 252.334 236.271 252.164C226.432 251.938 218.982 242.003 222.618 231.84Z"
            fill="#E1472A"
          />
          <path
            d="M223.73 229.852C227.3 219.722 238.526 219.76 242.924 221.056C245.596 215.992 249.823 209.73 259.566 210.494C267.992 211.154 273.427 221.183 270.987 233.478C268.351 246.761 260.589 258.133 259.574 256.09C256.623 250.151 244.667 250.386 237.356 250.189C227.59 249.927 220.159 239.982 223.73 229.852Z"
            fill="#FF5130"
          />
          <path
            d="M273.578 191.855C268.55 184.806 259.099 186.697 255.994 188.702C252.796 185.379 247.69 180.715 240.829 184.566C235.438 187.592 232.803 195.389 238.734 205.101C243.268 212.524 249.8 219.877 250.622 218.656C253.997 213.64 260.973 211.708 266.634 210.105C274.534 207.868 278.606 198.905 273.578 191.855Z"
            fill="#E1472A"
          />
        </g>
        <defs>
          <clipPath id="clip0_2087_157442">
            <rect
              width="83.3207"
              height="75.5094"
              fill="white"
              transform="translate(0 7)"
            />
          </clipPath>
          <clipPath id="clip1_2087_157442">
            <rect
              width="83.3207"
              height="75.5094"
              fill="white"
              transform="matrix(-1 0 0 1 276 7)"
            />
          </clipPath>
          <clipPath id="clip2_2087_157442">
            <rect
              width="80.717"
              height="85.9245"
              fill="white"
              transform="translate(0 181.453)"
            />
          </clipPath>
          <clipPath id="clip3_2087_157442">
            <rect
              width="80.717"
              height="85.9245"
              fill="white"
              transform="matrix(-1 0 0 1 276 181.453)"
            />
          </clipPath>
        </defs>
        {children}
      </g>
    </svg>
  );
}
